import { fromJS } from 'immutable';

const KEY = 'freebetCredits';

export function request( state, { id } ) {
    return state.setIn( [ KEY, parseInt( id, 10 ), 'status' ], 'IN_PROGRESS' );
}

export function error( state, { id, errors } ) {
    return state.setIn( [ KEY, parseInt( id, 10 ), 'status' ], 'ERROR' )
        .setIn( [ KEY, id, 'errors' ], fromJS(errors) );
}

export function finish( state, { id, data } ) {
    return state.setIn( [ KEY, parseInt( id, 10 ), 'status' ], 'FINISHED' )
        .setIn( [ KEY, id, 'data' ], fromJS(data) );
}
